import styled, { css } from 'styled-components';
import { StyledFlex } from '@tryhackme/thm-ui-components';

const commonStyles = css`
  color: ${({ theme }) => theme.colors.text.main};
  font-size: 1.8rem;
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
`;

export const StyledContent = styled.div`
  padding: 0 1.6rem 2rem;
`;

export const StyledBadgeContent = styled(StyledFlex)`
  justify-content: flex-start;
  justify-content: center;
  flex-wrap: nowrap;
  gap: 1rem;
  margin: 3rem 0;
  padding: 0 6.4rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    padding: 0;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.sm}) {
    display: block;
    padding: 0;
  }

  img {
    width: 12.7rem;
  }

  p:last-child {
    color: ${({ theme }) => theme.colors.paragraph};
  }

  &[data-modal='congratulations'] {
    margin: 0;
    img {
      width: 25.5rem;
      height: auto;
    }

    @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
      img {
        width: 19rem;
      }
    }

    @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
      display: block;
      text-align: center;
      margin: 0 auto;
    }
  }
`;

export const StyledBadgeTitle = styled.p`
  ${commonStyles};
  margin-bottom: 0.6rem;
  &[data-modal='congratulations'] {
    font-size: 3.2rem;
    margin-bottom: 1.6rem;
  }
`;

export const StyledMessage = styled.p`
  ${commonStyles};
  text-align: center;

  &[data-modal='congratulations'] {
    font-size: ${({ theme }) => theme.fonts.sizes.medium};
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.sm}) {
    text-align: left;
  }
`;
